// extracted by mini-css-extract-plugin
module.exports = {"divider":"Rotate_divider__yqZzf","Rotate":"Rotate_Rotate__2Tt6Y"};